// Should comply with app config settings in azure rg
export enum Toggle {
	kyc = 'toggling:kyc',
	deposits = 'toggling:deposits',
	loans = 'toggling:loans',
}
